import { Props } from 'shared/@types';
import { CookiePolicyScreen } from 'shared/screens/cookie-policy';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useTranslation } from 'react-i18next';

export default function CookiePolicy(props: Props) {
  const { t } = useTranslation('web');

  return (
    <Page {...props} register={(seo) => seo.setTitle(t('layout.footer.cookie_policy'))}>
      <CookiePolicyScreen />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
